import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';
import { fomateDate, stripHtmlTags, getLeafCategoryName } from '../../utils/fomateDate';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { deletemultipleProductsThunk, deleteProductThunk, setAllProductsFilters, setAllProductsSelected, setSelectallproduct, setSelectedproductids } from '../../redux/productSlice';
import { Edit, Edits, MultipleDeletes } from '../../Svg';
import UpdateInventoryModal from '../reusable/passwordModal/UpdateInventoryModal';


// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
  overflowX: 'auto',
  maxWidth: '100%',
  width: '100%',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '8px 6px',
  fontFamily: `'Public Sans', sans-serif !important`,
  whiteSpace: 'nowrap',
}));

const TableCells = styled(TableCell)(({ theme }) => ({
  padding: '8px 6px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '8px 6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  padding: '8px 6px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const formatUnitPrice = (item) => {
  if (!item) return "_";
  const hasQty = item.breakQty !== undefined && item.breakQty !== null && item.breakQty !== "";
  const hasPrice = item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "";
  if (hasQty && hasPrice) return `${item.breakQty} : ₹${item.unitPrice}`;
  if (hasPrice) return `₹${item.unitPrice}`;
  if (hasQty) return `${item.breakQty} : _`;
  return "_";
};

const formatSalePrice = (item, gstRate) => {
  if (!item) return "_";
  const hasQty = item.breakQty !== undefined && item.breakQty !== null && item.breakQty !== "";
  let finalP = item.finalPrice;
  if ((finalP === undefined || finalP === null || finalP === "") && item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "") {
    finalP = (Number(item.unitPrice) * (1 + Number(gstRate || 18) / 100)).toFixed(3);
  } else if (finalP !== undefined && finalP !== null && finalP !== "") {
    finalP = Number(finalP).toFixed(3);
  }
  const hasPrice = finalP !== undefined && finalP !== null && finalP !== "";
  if (hasQty && hasPrice) return `${item.breakQty} : ₹${finalP}`;
  if (hasPrice) return `₹${finalP}`;
  if (hasQty) return `${item.breakQty} : _`;
  return "_";
};

const ProductsTable = ({ product, start, end, setPage, page, itemsPerPage, totalItems, handleOpenMenu, selectionFilters, onBrowseCategories }) => {

  const [selectedId, setSelectedId] = useState(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false)
  const { selectedIds, allProductsSelected, allProductsFilters } = useSelector((state) => state.products);
  const { user } = useSelector((state) => state.user);

  const isSuperAdmin = () => {
    const role = user?.type || user?.role || user?.user?.type || user?.user?.role;
    return role && role.toString().toUpperCase() === 'SUPERADMIN';
  };

  const handleEditClick = (id) => {
    // dispatch(setEditCategory(category));
    navigate(`/products/editProduct/${id}`)
  };


  const deleteCategory = (password) => {
    dispatch(deleteProductThunk({ id: selectedId, password }))
    setIsModalOpen(false);
  }


  const handleDeleteClick = (id) => {
    if (!isSuperAdmin()) {
      toast.error("Only Super Admin is authorized to delete products");
      return;
    }
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const handleUpdateInventory = (id) => {
    setSelectedId(id)
    setIsOpen(true);
  }



  const visibleProductIds = product?.map((item) => item?._id).filter(Boolean) || [];
  const selectedCount = allProductsSelected ? (Number(totalItems) || 0) : selectedIds.length;
  const hasSelection = selectedCount > 0;
  const isPageSelected = allProductsSelected || (
    visibleProductIds.length > 0 && visibleProductIds.every((id) => selectedIds.includes(id))
  );

  const clearSelection = () => {
    dispatch(setSelectedproductids([]));
    dispatch(setSelectallproduct(false));
    dispatch(setAllProductsSelected(false));
    dispatch(setAllProductsFilters(null));
  };

  const handleSelect = (id) => {
    if (allProductsSelected) return;

    const isExist = selectedIds.includes(id)
    if (isExist) {
      const filter = selectedIds?.filter(i => i !== id)
      dispatch(setSelectedproductids(filter));
      return dispatch(setSelectallproduct(visibleProductIds.every((productId) => filter.includes(productId))));
    }
    const data = [...selectedIds, id]
    dispatch(setSelectedproductids(data));
    dispatch(setSelectallproduct(visibleProductIds.every((productId) => data.includes(productId))));
  }


  const handleSelectAll = () => {
    if (allProductsSelected) {
      return clearSelection();
    }

    const ids = isPageSelected
      ? selectedIds.filter((id) => !visibleProductIds.includes(id))
      : [...new Set([...selectedIds, ...visibleProductIds])];
    dispatch(setSelectedproductids(ids));
    dispatch(setSelectallproduct(!isPageSelected));
  };

  const selectAllProducts = () => {
    dispatch(setSelectedproductids([]));
    dispatch(setSelectallproduct(true));
    dispatch(setAllProductsSelected(true));
    dispatch(setAllProductsFilters(selectionFilters));
  };

  const handleMultipleDeleteClick = () => {
    if (!isSuperAdmin()) {
      toast.error("Only Super Admin is authorized to delete products");
      return;
    }
    setIsBulkModalOpen(true);
  }

  const confirmMultipleDelete = (password) => {
    const data = {
      ids: selectedIds,
      password,
      selectAll: allProductsSelected,
      filters: allProductsFilters
    }
    dispatch(deletemultipleProductsThunk(data))
    setIsBulkModalOpen(false);
  }


  return (
    <>
      {hasSelection && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 16px',
          marginBottom: '12px',
          backgroundColor: '#EEF2FF',
          border: '1px solid #C7D2FE',
          borderRadius: '8px',
          color: '#3730A3',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          <div>
            <strong>{selectedCount}</strong> product(s) selected
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button
              onClick={selectAllProducts}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#4F46E5',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '13px',
                textDecoration: 'underline'
              }}
              title="Select all matching products"
            >
              Select All Products
            </button>
            <button
              onClick={() => {
                clearSelection();
              }}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#4F46E5',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '13px',
                textDecoration: 'underline'
              }}
            >
              Deselect All
            </button>
            <button
              onClick={handleMultipleDeleteClick}
              style={{
                background: '#DC2626',
                border: 'none',
                color: '#FFFFFF',
                borderRadius: '6px',
                padding: '6px 12px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              Delete Selected ({selectedCount})
            </button>
          </div>
        </div>
      )}
      <TableContainerStyled component={Paper}>
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <HeaderCell sx={{ width: '20%' }}>
                <IconButton size="small" sx={{ padding: '1px' }}>
                  <input
                    type="checkbox"
                    checked={isPageSelected}
                    onChange={handleSelectAll}
                  />
                </IconButton>
                Product
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('product_name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '12%' }}>
                <span
                  onClick={onBrowseCategories}
                  title="Browse Level 3 categories"
                  style={{ cursor: 'pointer', color: '#512DA8', textDecoration: 'underline' }}
                >
                  Category
                </span>
              </HeaderCell>

              <HeaderCell sx={{ width: '8%' }}>
                Stock
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('inventory.stock')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '11%' }}>
                Unit Price
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('pricing.sale_price')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '6%' }}>
                GST
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('pricing.sale_price')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '11%' }}>
                Sale Price
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('pricing.sale_price')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '10%' }}>
                Status
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '12%' }}>
                Added
                <IconButton size="small" sx={{ padding: '1px' }} onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ width: '10%' }}>
                Action
                {hasSelection &&
                  <IconButton size="small" sx={{ padding: '1px' }} onClick={handleMultipleDeleteClick}>
                    <MultipleDeletes />
                  </IconButton>
                }
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {product?.map((row) => (
              <TableRow key={row._id || row.id}>

                <TableCells sx={{ width: '20%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <div>
                      <input
                        type="checkbox"
                        checked={allProductsSelected || selectedIds.includes(row?._id)}
                        onChange={() => handleSelect(row?._id)}
                        disabled={allProductsSelected}
                      />
                    </div>
                    <div>
                      {
                        row?.assets?.featuredImage ? <img src={row?.assets?.featuredImage} style={{ width: 40, height: 40, borderRadius: 2 }} /> : <img src="/assets/profile.png" style={{ width: 40, height: 40 }} />
                      }
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <strong style={{ color: '#1D1F2C', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '13px' }}> {row?.productOverview?.productNumber[0]}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', maxWidth: 110, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={stripHtmlTags(row?.productOverview?.description?.[0])}>
                        {stripHtmlTags(row?.productOverview?.description?.[0])}
                      </div>
                    </div>
                  </div>
                </TableCells>

                <ProductText sx={{ width: '12%', wordBreak: 'break-all', textWrap: 'wrap', fontSize: '13px' }}>
                  {getLeafCategoryName(row?.categories)}
                </ProductText>
                <ProductText sx={{ width: '8%', fontSize: '13px' }}>
                  {row?.inventory?.qtyAvailable ?? 0} <span onClick={() => handleUpdateInventory(row)} style={{ cursor: 'pointer' }}><Edits /></span>
                </ProductText>
                <ProductText sx={{ width: '11%', fontSize: '13px' }}>
                  {formatUnitPrice(row?.quantityTable?.[0])}
                </ProductText>
                <ProductText sx={{ width: '6%', fontSize: '13px' }}>{row?.gst ? `${row.gst}%` : `_`}</ProductText>
                <ProductText sx={{ width: '11%', fontSize: '13px' }}>
                  {formatSalePrice(row?.quantityTable?.[0], row?.gst)}
                </ProductText>

                <TableCells sx={{ width: '10%' }}>
                  {row?.status === "PUBLISHED" ? (
                    <ActiveChip label="Published" size="small" />
                  ) : (
                    <InactiveChip label="OUT OF STOCK" size="small" />
                  )}
                </TableCells>

                <TableCells sx={{ width: '12%', fontSize: '13px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/products/viewProduct/${row?._id}`)}
                  editClick={() => handleEditClick(row?._id)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                />

              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

      <DeleteModal
        isOpen={isModalOpen}
        title="Delete Product"
        description="Are you sure you want to delete this product?"
        onClose={() => setIsModalOpen(false)}
        onDelete={deleteCategory}
      />
      <DeleteModal
        isOpen={isBulkModalOpen}
        title="Delete Selected Products"
        description={`Are you sure you want to delete the ${selectedCount} selected product(s)?`}
        onClose={() => setIsBulkModalOpen(false)}
        onDelete={confirmMultipleDelete}
      />
      <UpdateInventoryModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        datas={selectedId}
      />

    </>
  );
};

export default ProductsTable;
